<template>
  <c-img
    :src="$config.image_profile_banner"
    ratio="9/5"
    data-test="profile-banner-img"
  />
  <v-container class="account-container" data-test="profile-page">
    <v-card class="bg-white bg-primary-light p-3" data-test="profile-general-panel" flat>
      <div class="content-between mb-6">
        <span
          data-lang="profile_general"
          class="f-body f-bold"
          data-test="profile-general-title"
        >{{ $t("profile_general") }}</span>
        <v-spacer></v-spacer>
        <div data-lang="edit"
          class="p-0 text-underline"
          v-if="!isEditing"
          variant="text"
          @click="editProfile"
          data-test="profile-general-edit-btn"
        >
          {{ $t("edit") }}
        </div>

        <font-awesome-icon
          v-if="!isEditing"
          icon="chevron-right"
          size="xs"
          class="ml-2"
        ></font-awesome-icon>
      </div>

      <v-list v-if="!isEditing" class="profile" data-test="profile-info-list">
        <template v-for="(value, key) in userInfo" :key="key">
          <v-list-item v-if="userInfo[key].display" class="px-0"
              :data-test="`profile-info-item-${key}`"
            >
            <v-list-item-title class="mb-1"
                :data-test="`profile-info-item-${key}-label`"
              >{{ userInfo[key].display }}
              <span v-if="$isMinimalMinibar">*</span>
            </v-list-item-title>
            <v-list-item-subtitle
                class="color-black"
                :data-test="`profile-info-item-${key}-value`">{{
              userInfo[key].value || "-"
            }}</v-list-item-subtitle>
          </v-list-item>
        </template>
      </v-list>

      <v-form v-else data-test="profile-edit-form">
        <EditProfilePanel
          @onFinish="onFinish"
          @closeEditPanel="closeEditPanel"
          componentKey
        />
      </v-form>
    </v-card>
    <v-card
      class="bg-white bg-primary-light p-3 mt-3"
      flat
      data-test="profile-menu-logout-panel"
    >
      <v-list-item>
        <div
          class="d-flex align-items-center text-underline"
          @click="$emit('logout')" data-test="profile-menu-logout-btn"
        >
          <div>
            <c-img
              :src="require('@/assets/images/clean/logout.png')"
              @error="handleImageSrc"
              style="width: 15px; height: 15px"
              alt="user icon tabs"
              class="mr-2 mb-1"
            />
          </div>
          {{ $t("logout") }}
        </div>
      </v-list-item>
    </v-card>
  </v-container>

  <ModalQrCode
    ref="qrCode"
    :value="qrType == 'Telephone' ? profile.telephone : profile.member_id"
    data-test="profile-qr-modal"
  />
  <ModalLoading ref="modalLoading" data-test="profile-loading-modal" />
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent, h } from "vue";
import ModalLoading from "@/components/other/ModalLoading.vue";

import tabUserIcon from "@/assets/images/user-tabs.png";
export default {
  components: {
    // ModalQrCode,

    ModalLoading,
    // EditProfilePanel,

    EditProfilePanel: defineAsyncComponent({
      loader: () => import("@/views/page/editprofile/editProfilePanel"),
      delay: 200,
      timeout: 10000,
      loadingComponent: {
        render() {
          return h("div", { class: "pa-4" }, "กำลังโหลด EditProfile...");
        }
      },
      errorComponent: {
        render() {
          return h(
            "div",
            { class: "pa-4 red--text" },
            "โหลด EditProfile ไม่สำเร็จ"
          );
        }
      }
    }),

    ModalQrCode: defineAsyncComponent(() =>
      import("@/components/profile/modal/ModalQrCode")
    ),

    ConpouPage: defineAsyncComponent(() => import("./page/CouponPage.vue")),
    Spinner: defineAsyncComponent(() =>
      import("@/components/other/Spinner.vue")
    )
  },

  data() {
    return {
      activeTab: "account",
      isEditing: false,
      user: {
        ...this.profile
      },
      qrType: this.$store.state.theme.qr_code,
      profileEdit: {},
      menu: false,
      date: null,
      userInfo: {},
      mainProps: {
        center: true,
        fluidGrow: false,
        blank: true,
        blankColor: "#bbb",
        width: 300,
        height: 300,
        class: ""
      },
      tabUserIcon,
      displayPage: 1,
      menuMore: false,
      customLink: []
    };
  },
  watch: {},
  async created() {
    this.setProfile();
    this.getCustomLink();
  },
  computed: {
    ...mapState({
      profile: state => state.shortProfile
    }),

    layoutComponent() {
      const loader = this.$isCleanLayout
        ? () => import("./page/cleanLayout/PurchaseTab.vue")
        : () => import("./page/PurchaseTab.vue");

      return defineAsyncComponent({
        loader,
        delay: 200,
        timeout: 10000,
        loadingComponent: {
          render() {
            return h("div", { class: "pa-4" }, "Loading..");
          }
        },
        errorComponent: {
          render() {
            return h(
              "div",
              { class: "pa-4", style: "color:red" },
              "โหลดไม่สำเร็จ"
            );
          }
        }
      });
    },

    fullName() {
      const first_name = this.profile.first_name_th
        ? this.profile.first_name_th
        : this.profile.first_name_th;
      const middle_name = this.profile.middle_name_th
        ? this.profile.middle_name_th
        : "";
      const last_name = this.profile.last_name_th
        ? this.profile.last_name_th
        : "";
      return first_name + " " + middle_name + " " + last_name;
    },
    birthday() {
      return this.$moment(this.profileEdit.birthday)
        .subtract(543, "year")
        .format("DD/MM/YYYY");
    }
  },
  methods: {
    async setProfile() {
      const data = await this.$store.dispatch(
        "getProfileFields",
        this.profile.login_type == 2 ? 3 : this.profile.login_type
      );
      const findDisplayName = id => {
        let find =
          data.detail.result.fields.find(el => el.field_profile_type_id == id)
            ?.field_language || [];
        if (find.length > 0) return find[0].name + " *";
        return (
          data.detail.result.fields.find(el => el.field_profile_type_id == id)
            ?.name || id
        );
      };
      const findChoiceName = (id, value) => {
        let find =
          data.detail.result.fields.find(el => el.field_profile_type_id == id)
            ?.field_choices || [];
        if (find.length > 0)
          return (
            find.find(el => el.id == value)?.display_name ||
            find[0].display_name
          );
        return id;
      };

      const province = await this.$store.dispatch("getProvince");

      let selectProvince = province.find(
        el => el.name == this.profile.province
      );

      this.userInfo = {
        first_name: {
          display: findDisplayName(3),
          value: this.profile.first_name_th
            ? this.profile.first_name_th
            : this.profile.first_name_th
        },

        last_name: {
          display: findDisplayName(5),
          value: this.profile.last_name_th
            ? this.profile.last_name_th
            : this.profile.last_name_th
        },

        email: {
          display: findDisplayName(11),
          value: this.profile.email
        },
        telephone: {
          display: findDisplayName(10),
          value: this.profile.telephone ? this.profile.telephone : ""
        },
        birthday: {
          display: findDisplayName(9),
          value: this.profile.birthday
            ? this.$moment(this.profile.birthday).format("DD/MM/YYYY")
            : ""
        },
        gender: { display: findDisplayName(21), value: this.profile.gender }
      };
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`; // เปลี่ยนเป็น DD/MM/YYYY
    },
    editProfile() {
      this.profileEdit = {
        ...this.profile,
        birthday: new Date(this.$moment(this.profile.birthday).format()),
        full_name: this.profile.first_name_th + " " + this.profile.last_name_th
      };
      this.isEditing = true;
    },

    async onFinish() {
      await this.$store.dispatch("refreshUserProfile");
      await this.setProfile();
      this.isEditing = false;
    },
    closeEditPanel() {
      this.isEditing = false;
    },
    classCard() {
      if (this.$isShowTab)
        return "border-sm rounded-4 p-3 bg-profile-card bg-primary-light";
      if (this.$isMinimalMinibar)
        return "p-3 bg-minibar-card  bg-primary-light";
      return "";
    },
    async getCustomLink() {
      const res = await this.$axios("/api/v1/setting/customlink/list");
      this.customLink = res.detail.filter(el => el.status == 1);
    },
    openLink(value) {
      let url = this.getUrlLink(value);
      if (this.customLink.length > 1) return;
      function isValidHttpUrl(string) {
        let url;
        try {
          url = new URL(string);
        } catch (_) {
          return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
      }
      let check = isValidHttpUrl(url);

      return !check ? window.open("https://" + url) : window.open(url);
    },
    getUrlLink(link) {
      let lang = this.$cookies.get("lang");
      let getURL = link.details.find(el => el.language_id == lang.lang);
      return getURL.url;
    }
  }
};
</script>

<style scoped lang="scss">
.account-container {
  overflow-y: hidden;
  padding-bottom: calc(var(--padding-footer) + 10px);
  // padding-top: 0;
}

.welcome-text {
  font-size: var(--font-body-lg);
}

.member-id {
  font-size: var(--font-body);
}

.v-list-item {
  padding: 0;
  padding-inline: 0 !important;
}

:deep(.v-tab.v-tab--selected) {
  // font-weight: bold !important;
  opacity: 1;
}

:not(.tab-minibar) v-tab.v-tab.v-btn {
  // min-width: 150px;
  padding-top: 10px;
}
.logout {
  position: absolute;
  top: 0;
  right: 0;
  height: max-content !important;
  /* font-size: 12px; */
}

::v-deep.logout .v-btn__content {
  font-size: var(--font-body-sm);
}

.footer-tab {
  position: fixed;
  bottom: 15px;
  width: 100%;
  background-color: var(--theme-background-color);
  padding: 5px 15px 40px 15px; // border-top: 1px solid #f7f7f7;
  ::v-deep button {
    border-top: 1px solid;
    border-color: transparent;
  }
  .active-tab {
    border-color: black;
  }
  .active-tab-minibar {
  }
}

.logo-profile {
  width: 100%;
  max-width: 80%;
}

.footer-line {
  height: 1px;
  left: 0;
  width: 100vw;
  position: absolute;
  top: 0;
  border: thin solid #f7f7f7;
}
.icon-tabs {
  width: 20px;
  height: 20px;
}
.pencil-icon {
  width: 12.5px;
  height: 12.5px;
}
.tab-minibar {
  background: var(--bar-color);
  padding: 10px 16px;
  width: 100%;
  border-radius: 4px;
}
.minibar-tab-active {
  background-color: white;
  padding: 0.5rem;
  border-radius: 50%;
}
::v-deep .v-label.v-field-label {
  margin-inline-start: unset !important;
}
::v-deep .v-text-field input,
::v-deep .v-field__input {
  padding-inline: unset !important;
}
.img-banner {
  aspect-ratio: 16 / 9;
}
</style>
